import { isBlank } from '../utils/lang'

export function getQueryParams(params: any) {
  if (isBlank(params)) return {}

  return Object.keys(params).reduce((previous, key, index) => {
    if (key === 'sort') {
      const sortKey = Object.keys(params[key])[0]

      return isBlank(sortKey) ? previous : { ...previous, sortColumn: sortKey, sortDirection: params[key][sortKey] }
    }

    if (key === 'filter') {
      const searchKey = Object.keys(params[key])[0]

      return isBlank(searchKey) ? previous : { ...previous, ...params[key] }
    }

    if (key === 'conditions') {
      return { ...previous, ...params.conditions }
    }

    return { ...previous, [key]: params[key] }
  }, {})
}

export function serialize(params: any, prefix?: string): string {
  const queryString = []

  for (const param in params) {
    if (params.hasOwnProperty(param)) {
      const k = prefix ? `${prefix}[${param}]` : param
      const v = params[param]
      queryString.push(
        v !== null && typeof v === 'object' ? serialize(v, k) : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
      )
    }
  }

  return queryString.join('&')
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/getQueryParams.ts